import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "use-intl";
import useAuth from "@/shared/hooks/use-auth";
import { useEffect } from "react";

export default function UnauthorizedError({ routeTo }: { routeTo: string }) {
  const navigate = useNavigate();
  const { logout, isAuthenticated } = useAuth();
  const t = useTranslations("error");

  // Automatically log the user out when they land on this page (if authenticated)
  useEffect(() => {
    if (isAuthenticated) {
      logout();
    }
  }, [isAuthenticated, logout]);

  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <h1 className="text-[7rem] font-bold leading-tight">401</h1>
        <span className="font-medium">{t("unauthorized_title")}</span>
        <p className="text-center text-muted-foreground">
          {t.rich("unauthorized_desc", { br: () => <br /> })}
        </p>
        <div className="mt-6 flex gap-4">
          <Button variant="outline" onClick={() => navigate(-1)}>
            {t("go_back")}
          </Button>
          <Button onClick={() => navigate(routeTo)}>{t("back_to_home")}</Button>
        </div>
      </div>
    </div>
  );
}
